import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DSVRowArray } from 'd3';
import { Store } from '@ngxs/store';
import { DashboardDataController } from 'src/app/dashboards/shared/data_controller/dashboard_data_controller';
import { DatasetsService } from 'src/app/shared/services/datasets.service';
import { LocalDatasetsService } from 'src/app/shared/services/local-datasets.service';
import { DataSlice } from 'src/app/state/library/library.model';
import { SliceDashboardConfigFactory } from './slice-dashboard-config.factory';

@Injectable({ providedIn: 'root' })
export class SliceChartDataResolver {

  constructor(
    private datasetsService: DatasetsService,
    private store: Store,
    private localDatasetsService: LocalDatasetsService,
    private router: Router,
    private configFactory: SliceDashboardConfigFactory,
  ) {}

  /** Re-run the dashboard data pipeline for a saved slice recipe. */
  async resolveChartData(slice: DataSlice): Promise<DSVRowArray | null> {
    const controller = new DashboardDataController(
      this.datasetsService,
      this.store,
      this.localDatasetsService,
      this.router,
    );

    const config = this.configFactory.resolve(slice, controller);
    if (!config) {
      return null;
    }

    controller.configureForSliceResolve(config, slice.datasetName);
    controller.setFilterValuesIgnoreMissing(this._toFilterMap(slice.filterValues));

    const { filterValues, filtersEnabled } = controller.snapshotFilterState();
    return controller.resolveChartDataOnce(filterValues, filtersEnabled);
  }

  private _toFilterMap(filterValues: Record<string, unknown>): Map<string, any> {
    return new Map(Object.entries(filterValues));
  }
}
